import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
import { MainScene } from "./MainScene";
import { GameIntroScene } from "./GameIntro";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();
        this.gameRef = Games.DesertTerraform;
        this.mainScene = MainScene;
        this.gameIntroScene = GameIntroScene;
        this.gameObjectiveTextKey = "DesertTerraform.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "DesertTerraform.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "DesertTerraform.Phaser.HowToPlay.tabletInstructions";
    }
}



// WEBPACK FOOTER //
// ./src/games/DesertTerraformGame/scenes/IntroductionScene.ts